import React, { useEffect, useState } from 'react';

const SearchButton = ({ searchOpen, searchStatus }) => {
	const [open, setOpen] = useState(false);

	useEffect(() => {
		setOpen(searchStatus);
	}, [searchStatus]);

	return (
		<button
			className={`search-button${open ? ' opened' : ''}`}
			onClick={() => {
				setOpen(!open);
				searchOpen(open);
			}}
		>
			<div className="circle"></div>
			<div className="bar"></div>
		</button>
	);
};

export default SearchButton;
